'use client'

import { SetStateAction, useEffect, useState } from "react";
import Image from "next/image";
import { FileUploader } from "react-drag-drop-files";
import Upload from "./upload";
import classNames from "classnames";

interface UploadProps {
  title: string;
  open: boolean;
  onClose: () => void;
  buttonText: string;
  image?: string;
  subtitle?: string;
  fileTypes?: string[];
  multiple?: boolean;
}

export default function UploadModal(props: UploadProps) {
  const [uploadFile, setFile] = useState<File | null>(null);
  const [open, setOpen] = useState<boolean>(props.open);
  const [showSizeLimitError, setShowSizeLimitError] = useState(false);

  // const fileTypes = ["PDF"];
  const fileTypes = props.fileTypes || ["PDF"];
  const image = props.image || "/img/pdf-icon.svg";
  const subtitle = props.subtitle || "Drop PDF Files Here";
  const multiple = props.multiple || false;


  const handleClose = () => {
    props.onClose();
  }

  useEffect(() => {
    setOpen(props.open)
    setShowSizeLimitError(false);
  }, [props.open]);

  const handleChange = async (file: any) => {
    setFile(file);

    // const reader = new FileReader();
    // reader.readAsDataURL(uploadFile!);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await fetch("/api/fileupload", {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        console.error("something went wrong, check your console.");
        return;
      }

      const data: { fileUrl: string } = await res.json();

      window.location.href = "/userdocument?file=" + data.fileUrl;

      // setImageUrl(data.fileUrl);
    } catch (error) {
      console.error("something went wrong, check your console.");
    }
  };
  const onSizeLimit = () => {
    setShowSizeLimitError(true);
  }

  return (
    <>
      {open ? (
        <>
          <div
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
          >
            <div className="relative w-full mx-5 md:w-2/6 my-6 md:mx-auto">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-xl md:text-3xl font-semibold">
                    {props.title}
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-100 float-right text-3xl leading-none font-semibold outline-none focus:outline-none "
                    onClick={handleClose}
                  >
                    <span className="bg-transparent text-black opacity-100 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>

                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative px-6 pb-8 flex-auto w-full d-flex justify-content-center flex-col">
                  <div className={classNames(" text-red-600 pt-10",
                    showSizeLimitError ? "block" : "hidden")}>
                    {showSizeLimitError ?
                      <span>The file exceed our limit of 20MB. Please contact support@usepdf.com for help</span>
                      : <span>&nbsp;</span>
                    }
                  </div>
                  <Upload
                    buttonText={props.buttonText}
                    title=""
                    onSizeLimit={onSizeLimit}
                    image={image}
                    subtitle={subtitle}
                    fileTypes={props.fileTypes}
                    multiple={multiple}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-50 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}